import { motion } from "framer-motion";

const chapters = [
  {
    n: "01",
    title: "Matéria-prima antes do marketing",
    text: "Cada lote é rastreado até a origem. Se um ingrediente não passa no nosso crivo, ele não entra no pote — simples assim. Preferimos vender menos a vender qualquer coisa.",
    img: "https://images.unsplash.com/photo-1649888381057-d5d03c105f82?w=1000&q=80",
    alt: "Atleta se alongando em luz natural",
  },
  {
    n: "02",
    title: "Ciência que cabe na rotina",
    text: "Produtos selecionados com cuidado para acompanhar você em cada momento. Porque cuidar de si também cabe numa segunda-feira qualquer.",
    img: "https://images.unsplash.com/photo-1548690312-e3b507d8c110?w=1000&q=80",
    alt: "Atleta segurando corda na academia",
  },
  {
    n: "03",
    title: "Mais que suplemento. Um ritual.",
    text: "Acordar. Treinar. Nutrir. Descansar. Pequenas escolhas que, juntas, fazem parte da sua rotina. A Leve Essenza está aqui para tornar esse caminho mais leve.",
    img: "https://images.unsplash.com/photo-1526506118085-60ce8714f8c5?w=1000&q=80",
    alt: "Mulher treinando com barra",
  },
];

export const Manifesto = () => (
  <section id="manifesto" data-testid="manifesto-section" className="bg-offwhite py-24 md:py-32 lg:py-40 overflow-hidden">
    <div className="w-full max-w-[1600px] mx-auto px-6 md:px-12 lg:px-24">
      <motion.div
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-100px" }}
        transition={{ duration: 0.8, ease: "easeOut" }}
        className="mb-24"
      >
        <p className="text-xs uppercase tracking-[0.3em] text-military font-semibold mb-4">02 · Manifesto</p>
        <h2 className="font-serif text-4xl md:text-6xl text-military-dark tracking-tight max-w-3xl">
          Três capítulos. <span className="italic font-light text-military">Uma obsessão.</span>
        </h2>
      </motion.div>

      <div className="space-y-32 md:space-y-48">
        {chapters.map((c, i) => (
          <motion.div
            key={c.n}
            data-testid={`manifesto-chapter-${c.n}`}
            initial={{ opacity: 0, y: 60 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-120px" }}
            transition={{ duration: 0.9, ease: "easeOut" }}
            className={`grid grid-cols-1 md:grid-cols-12 gap-8 items-center ${i % 2 === 1 ? "md:text-right" : ""}`}
          >
            <div className={`md:col-span-6 relative ${i % 2 === 1 ? "md:order-2" : ""}`}>
              <span className="absolute -top-16 -left-4 font-serif text-[10rem] md:text-[14rem] leading-none text-military/10 select-none z-0">{c.n}</span>
              <div className={`relative z-10 ${i % 2 === 1 ? "md:pl-16" : "md:pr-16"}`}>
                <h3 className="font-serif text-3xl md:text-5xl text-military-dark leading-tight mb-6">{c.title}</h3>
                <p className="text-base md:text-lg text-military-dark/70 leading-relaxed max-w-lg inline-block">{c.text}</p>
              </div>
            </div>
            <div className={`md:col-span-6 ${i % 2 === 1 ? "md:order-1 md:-mr-12" : "md:-ml-12"}`}>
              <motion.div
                initial={{ clipPath: "inset(0 0 100% 0)" }}
                whileInView={{ clipPath: "inset(0 0 0% 0)" }}
                viewport={{ once: true, margin: "-120px" }}
                transition={{ duration: 1.1, ease: [0.76, 0, 0.24, 1] }}
                className={`overflow-hidden rounded-lg ${i % 2 === 1 ? "-rotate-2" : "rotate-2"} shadow-[0_30px_60px_rgba(43,54,38,0.12)]`}
              >
                <img src={c.img} alt={c.alt} loading="lazy" className="w-full aspect-[4/3] object-cover" />
              </motion.div>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
